import QRCode from 'qrcode'

const REVOKE_AFTER_MS = 1000

export const qrCodeDataUrl = (text, { width = 240 } = {}) => QRCode.toDataURL(text, { width })

const dataUrlToBlob = dataUrl => {
  const [header, base64] = dataUrl.split(',')
  const type = header.slice('data:'.length).split(';')[0]
  const bytes = Uint8Array.from(atob(base64), char => char.charCodeAt(0))
  return new Blob([bytes], { type })
}

export const qrCodePngBlob = (text, { width = 1024 } = {}) => qrCodeDataUrl(text, { width }).then(dataUrlToBlob)

export const canCopyImages = () =>
  typeof window !== 'undefined' &&
  typeof window.ClipboardItem === 'function' &&
  typeof navigator.clipboard?.write === 'function'

export async function copyImageToClipboard(blobPromise) {
  const item = new window.ClipboardItem({ 'image/png': blobPromise })
  await navigator.clipboard.write([item])
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  setTimeout(() => URL.revokeObjectURL(url), REVOKE_AFTER_MS)
}
